"use client";

import { WIDTH_2COL } from "@constants/global";
import { ExploreSidePanelV2 } from "./ExploreSidePanelV2";
import { ExploreTimelinePanelV2 } from "./ExploreTimelinePanelV2";
import { useVendor } from "context/vendor/vendor.provider";
import useWindowSize from "utils/hooks/useWindowSize";
import { AppPageLayoutV2 } from "../layout/AppPageLayoutV2";

/**
 * Shell v2 canónico para /app/explore.
 *
 * La página no debe declarar layout/CSS propios: todo vive acá para mantener
 * Explore como una superficie v2 componetizada. Los componentes feature
 * existentes (timeline, side panels) se montan dentro de este shell hasta que
 * sus internals terminen de migrarse a primitives v2.
 */
export function ExplorePageLayoutV2() {
  const wWidth = useWindowSize()?.width;
  const isTwoCol = wWidth >= WIDTH_2COL;
  const { vendor } = useVendor();

  return (
    <AppPageLayoutV2 withFrame={false} outerPadding="none">
      <div className="explore-page-shell-v2">
        <div className="explore-page-shell-v2__container">
          <section className="explore-page-shell-v2__timeline" aria-label="Timeline">
            <div className="h-full">
              <ExploreTimelinePanelV2 />
            </div>
          </section>

          <aside className="explore-page-shell-v2__side-panel" aria-label="Panel lateral de Explore">
            <div className="h-full">
              <ExploreSidePanelV2 render={isTwoCol} vendor={vendor} />
            </div>
          </aside>
        </div>
      </div>

      {/*
        El toggle del side-panel mobile ahora se monta DENTRO de la fila de
        historias (ver `ExploreStoriesInline`), alineado a la derecha y
        oculto automáticamente sobre el breakpoint `WIDTH_2COL` (1140px),
        cuando el panel ya está visible.
      */}

      <style jsx>{`
        .explore-page-shell-v2 {
          width: 100%;
          min-height: 0;
        }

        .explore-page-shell-v2__container {
          display: flex;
          flex-direction: column;
          width: 100%;
          max-width: var(--max-size-grid);
          gap: 1rem;
        }

        .explore-page-shell-v2__timeline {
          flex: 1;
          min-width: 0;
          min-height: 0;
        }

        .explore-page-shell-v2__side-panel {
          display: none;
          min-height: 0;
        }

        @media only screen and (min-width: ${WIDTH_2COL}px) {
          .explore-page-shell-v2__container {
            flex-direction: row;
            align-items: flex-start;
          }

          .explore-page-shell-v2__side-panel {
            display: block;
            width: 268px;
            flex-shrink: 0;
          }
        }

        .explore-page-shell-v2__timeline > :global(*),
        .explore-page-shell-v2__side-panel > :global(*) {
          position: relative;
          min-height: 0;
        }
      `}</style>
    </AppPageLayoutV2>
  );
}
